'use strict';
import Generator from 'yeoman-generator';
import chalk from 'chalk';
import yosay from 'yosay';
import utils from 'backed-utils';
import path from 'path';
import os from 'os';
const platform = os.platform();

export default class extends Generator {
  constructor(args, opts) {
    super(args, opts);

    // This method adds support for a `--coffee` flag
    this.option('default');
    this.argument('name', {type: 'string', required: false});
  }

  initializing() {
    const name = this.options.name || path.win32.basename(process.cwd());
    const _className = utils.toJsProp(name);
    const className = _className.charAt(0).toUpperCase() + _className.slice(1);
    this.props = {
      name: name,
      className: className
    };
  }

  prompting() {
    var prompts = [{
      type: 'input',
      name: 'name',
      message: 'Whats the name for your component?',
      default: this.props.name,
      when: !this.options.name
    }, {
      type: 'input',
      name: 'version',
      message: 'Version',
      default: '0.0.0'
    }, {
      type: 'input',
      name: 'description',
      message: 'Description',
      when: !this.props.description
    }, {
      type: 'input',
      name: 'homepage',
      message: 'Project homepage url',
      when: !this.props.homepage
    }, {
      type: 'input',
      store: true,
      name: 'authorName',
      message: 'Author\'s Name',
      default: this.user.git.name()
    }, {
      type: 'input',
      store: true,
      name: 'authorEmail',
      message: 'Author\'s Email',
      default: this.user.git.email()
    }, {
      type: 'input',
      store: true,
      name: 'authorUrl',
      message: 'Author\'s Homepage',
      default: ''
    }, {
      type: 'confirm',
      store: true,
      name: 'license',
      message: 'Include license?',
      default: true
    }, {
      type: 'input',
      name: 'keywords',
      message: 'Package keywords (comma to split)'
    }];

    if (this.options.default) return;
    else return this.prompt(prompts).then(props => {
      // To access props later use this.props.someAnswer;
      this.props = props;
    });
  }

  configuring() {
    this.composeWith(require.resolve('generator-node/generators/git'), {
      name: this.props.name || this.options.name,
      githubAccount: this.props.authorEmail
    });

    if (this.props.license) {
      this.composeWith(require.resolve('generator-license/app'), {
        name: this.props.authorName,
        email: this.props.authorEmail,
        website: this.props.authorUrl
      });
    }
  }

  writing() {
    this.fs.copy(
      this.templatePath('.*'),
      this.destinationPath('./')
    );

    this.fs.copyTpl(
      this.templatePath('package.json'),
      this.destinationPath('package.json'),
      {
        name: this.props.name || this.options.name,
        version: this.props.version,
        authorName: this.props.authorName,
        authorEmail: this.props.authorEmail,
        authorUrl: this.props.authorUrl
      }
    );

    this.fs.copyTpl(
      this.templatePath('backed.json'),
      this.destinationPath('backed.json'),
      {
        name: this.props.name || this.options.name
      }
    );

    this.fs.copyTpl(
      this.templatePath('backed-element.js'),
      this.destinationPath(`src/${this.props.name || this.options.name}.js`),
      {
        className: this.props.className
      }
    );

    this.fs.copyTpl(
      this.templatePath('backed-element.html'),
      this.destinationPath(`${this.props.name || this.options.name}.html`),
      {
        name: this.props.name || this.options.name
      }
    );

    this.fs.copyTpl(
      this.templatePath('demo.html'),
      this.destinationPath('demo/index.html'),
      {
        name: this.props.name || this.options.name
      }
    );
  }

  install() {
    try {
      console.log(chalk.yellow('backed version'))
      this.spawnCommandSync('backed', ['version']);
      console.log();
    } catch (e) {
      if (platform === 'win32') {
        this.spawnCommandSync('yarn', ['global', 'add', 'backed-cli']);
      } else {
        this.spawnCommandSync('sudo', ['yarn', 'global', 'add', 'backed-cli']);
      }
    }
    this.log('Swiping things up');
    this.spawnCommand('rm', ['-rf', 'node_modules']);

    this.installDependencies({
      bower: false,
      npm: false,
      yarn: true
    });
  }
}
